@if (appFooterContainerCSSClass) {
  <!--begin::Footer container-->
  <div class="app-container" [ngClass]="appFooterContainerCSSClass">
    <ng-container *ngTemplateOutlet="footerView"></ng-container>
  </div>
  <!--end::Footer container-->
}
@if (!appFooterContainerCSSClass) {
  <ng-container *ngTemplateOutlet="footerView"></ng-container>
}

<ng-template #footerView>
  <section class="d-flex flex-column w-100">
    @if (displaySection !== "copyright") {
      <!------------>

      <section
        class="d-flex flex-column flex-md-row flex-center align-items-start flex-md-stack my-14"
      >
        <div
          class="order-1 gap-4 order-md-1 d-flex flex-column justify-content-md-between min-h-78px col-12 col-md-4 col-lg-3"
        >
          <img
            alt="Logo"
            src="./assets/media/logos/brand-logo-white.svg"
            class="h-50px h-sm-60px w-fit"
          />
        </div>
        <!------------>
        <!-- <div
        class="order-2 mt-8 order-md-1 col-12 col-md-4 col-lg-3 d-flex flex-column justify-content-md-between mt-md-2 fs-lg"
      >
        <p class="mb-4 text-primary fs-2qx fw-bold">
          {{ "APP.APP_NAME" | translate }}
        </p>
        <div class="gap-4 d-flex flex-column col-12">
          @for (item of contactInfo; track $index) { @if($index < 2){
          <a
            class="flex-row gap-3 p-0 text-white menu-link d-flex text-decoration-hover-underline fs-3"
            [ngClass]="{
              'align-items-start': $index === 0,
              'align-items-center': $index != 0
            }"
          >
            @if(item.icon){

            <app-icon-svg [icon]="item.icon!" classes="icon-lg"></app-icon-svg>
            }
            {{ item.name }}
          </a>
          } }
        </div>
      </div> -->

        <!------------>

        <div
          class="order-2 mt-8 order-md-1 col-12 col-md-auto col-lg-auto d-flex flex-column justify-content-md-between mt-md-2 fs-lg"
        >
          <p class="mb-4 text-primary fs-2qx fw-bold">
            {{ "APP.SOCIAL_MEDIA" | translate }}
          </p>
          <div class="gap-4 d-flex flex-column col-12">
            @for (item of contactInfo; track $index) {
              @if ($index >= 2) {
                <a
                  class="flex-row gap-3 p-0 text-white menu-link d-flex text-decoration-hover-underline fs-3"
                  [ngClass]="{
                    'align-items-start': $index === 0,
                    'align-items-center': $index !== 0,
                  }"
                  [attr.href]="item.url"
                  target="_blank"
                >
                  @if (item.icon) {
                    <app-icon-svg
                      [icon]="item.icon!"
                      classes="icon-lg"
                    ></app-icon-svg>
                  }
                  {{ item.name }}
                </a>
              }
            }
          </div>
        </div>
      </section>
    }
    @if (displaySection === "full") {
      <hr class="border-dark" />
    }
    @if (displaySection !== "contact") {
      <section
        class="my-4 d-flex flex-column flex-sm-row align-items-start justify-content-between my-sm-6"
      >
        <!-- <div class="order-2 order-sm-1">
          <a class="text-xs text-muted"
            >Copyright © {{ currentDateStr }}
            <span class="text-primary"> EN-OT</span> All Rights
            Reserved. Powered by Riseplus Technology. Co.LTD.,</a
          >
        </div> -->
      </section>
    }
  </section>
</ng-template>
